import React, { CSSProperties } from 'react'

import styles from './styles.module.scss'

import { IEmptyStateCTAIcons } from './empty-state-cta.enum'
import {
  SvgCheck,
  SvgDateRange,
  SvgEmptyHouse,
  SvgHistory,
  SvgNotification,
  SvgPeople,
  SvgSearch,
  SvgSend,
} from './icons'
import { Button } from '../../atoms'

interface IEmptyStateCTA {
  onClick?: () => void
  label: string
  labelButton?: string
  icon: IEmptyStateCTAIcons
  style?: CSSProperties
}

const Icons = [
  { type: IEmptyStateCTAIcons.SEND, icon: <SvgSend /> },
  { type: IEmptyStateCTAIcons.CHECK, icon: <SvgCheck /> },
  { type: IEmptyStateCTAIcons.DATE_RANGE, icon: <SvgDateRange /> },
  { type: IEmptyStateCTAIcons.NOTIFICATIONS, icon: <SvgNotification /> },
  { type: IEmptyStateCTAIcons.HISTORY, icon: <SvgHistory /> },
  { type: IEmptyStateCTAIcons.PEOPLE, icon: <SvgPeople /> },
  { type: IEmptyStateCTAIcons.SEARCH, icon: <SvgSearch /> },
  { type: IEmptyStateCTAIcons.EMPTY_HOUSE, icon: <SvgEmptyHouse /> },
]

const EmptyStateCTA = ({
  icon,
  label,
  onClick,
  labelButton,
  style = {},
}: IEmptyStateCTA) => {
  return (
    <div className={styles.content} style={style}>
      {Icons.find((x) => x.type === icon)?.icon}

      <div className={styles.label}>{label}</div>

      {onClick && labelButton && (
        <Button onClick={() => onClick()} loading={false}>
          {labelButton}
        </Button>
      )}
    </div>
  )
}

export default EmptyStateCTA
